import { StrictMode } from 'react'
import '@fontsource-variable/inter'

import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import { initSentry } from '@analytics/sentry'
import { SENTRY_DSN } from '@constants'

import App from './App'

initSentry()

const options = SENTRY_DSN
  ? {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }
  : {}

createRoot(document.getElementById('root')!, options).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
